// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { UrlUtils } from '@shared/utils/UrlUtils';
export class Idea {
    constructor(msg, ins, tradingSystem) {
        this.limitPriceToShow = null;
        this.slPriceToShow = null;
        this.sllPriceToShow = null;
        this.tpPriceToShow = null;
        this.slPriceToShowFormatted = null;
        this.tpPriceToShowFormatted = null;
        this.slProfit = null;
        this.tpProfit = null;
        this.tifExpireAt = null;
        this.wasNotRead = null;
        this.createTime = null;
        this.expireTime = null;
        this.name = tradingSystem.name;
        this.companyName = tradingSystem.companyName;
        this.logoSrcBytes = tradingSystem.logoBytes;
        this.tradingSystemId = msg.TradingSystemId;
        this.title = msg.Title;
        this.description = msg.Description;
        this.descriptionParsedToHTML = this.UrlifyDescription(this.description);
        this.instrument = ins;
        this.instrumentLabel = ins ? ins.DisplayName() : '';
        this.buySide = OperationType.Buy === msg.OperationType;
        this.side = msg.OperationType;
        this.limitPrice = msg.OpenPrice;
        this.limitPriceToShow = null;
        this.slPrice = msg.SLPrice;
        this.sllPrice = msg.SLLPrice;
        this.tpPrice = msg.TPPrice;
        this.slPriceType = msg.SLPriceType;
        this.tpPriceType = msg.TPPriceType;
        this.tif = msg.Tif;
        this.tifExpireAt = msg.TifExpireAt;
        this.productTypeAnal = msg.ProductType;
        this.wasNotRead = msg.NotSeen;
        this.createTime = msg.CreateTime;
        this.expireTime = msg.ExpireTime;
        this.tradingSignalId = msg.TradingSignalId;
        this.lifeTime = DateTimeUtils.convertTicksToHHMMSS(msg.ExpireTime.getTime() - Date.now());
        this.AttachmentScreenPath = msg.AttachmentScreenPath;
        this.AttachmentFilePath = msg.AttachmentFilePath;
        this.hasAttachments = isValidString(this.AttachmentScreenPath) || isValidString(this.AttachmentFilePath);
        if (isValidString(this.AttachmentFilePath)) {
            this.attachExtension = this.AttachmentFilePath.substring(this.AttachmentFilePath.lastIndexOf('.'));
        } // get file extension
    }
    get id() {
        return this.tradingSignalId;
    }
    UrlifyDescription(descr) {
        return descr.replace(UrlUtils.urlRegex, function (url) {
            return ('<a target="_blank" class="idea-description-link" rel="noopener noreferrer" href="' +
                url +
                '">' +
                url +
                '</a>');
        });
    }
}
